import React, { Component } from "react";
import Info from "./Info";
import Address from "./Address";
import UserQR from "./QR";
import NotificationInfo from "./NotificationInfo"

class Profile extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <React.Fragment>
          <div className="info">
            <Info />
          </div>
          <div className="home">
            <Address mode="home" />
          </div>
          <div className="work">
            <Address mode="work" />
          </div>
          <div className="notificationInfo">
            <NotificationInfo />
          </div>
          <div className="qr">
            <UserQR />
          </div>
      </React.Fragment>
    );
  }
}

export default Profile;